import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type QuizzesCategory = {
   name: string;
};

export type GetQuizzesCategoriesResponse = {
   categories: QuizzesCategory[];
};

export type GetQuizzesCategoriesOptions = CommonRequestOptions;

export async function getQuizzesCategories({
   ...common
}: GetQuizzesCategoriesOptions = {}): Promise<GetQuizzesCategoriesResponse> {
   return makeRequest('get', '/quizzes/categories', { ...common });
}
